/**
 * 重置密码成功
 * 2017-12-6
 */
"use strict";
angular.module("fresetSuccessModule", []).controller("fresetSuccessCtrl", ['$scope', '$state', '$timeout', function ($scope, $state, $timeout) {
	initStatus();
	initData();

	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {};
		$scope.data = {
			listData: [],
		};
		$scope.page = {
			CURRPAGE: 1,
			PAGESIZE: 12,
			PAGECOUNT: 1,
			ITEMCOUNT: 0
		};
	}

	/**
	 * [initStatus description] 初始化数据
	 */
	function initData() {
		var timer = null;
		timer = $timeout(() => {
			window.close();
			$state.go("login", {}, {location: 'replace'});
			$timeout.cancel(timer);
		}, 3000)
	}


}]);
